if (!customElements.get('localization-form')) {
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
				button: this.querySelector('button'),
				panel: this.querySelector('.f-disclosure-list')
			};

			this.elements.panel.removeAttribute('hidden')
			this.elements.button.addEventListener('click', this.openSelector.bind(this));
			this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

			this.handleDropdownPos()
		}

		handleDropdownPos() {
			const offsetButton = this.elements.button.getBoundingClientRect().right
			if ((window.innerWidth - offsetButton) < 220) {
				this.elements.button.nextElementSibling && this.elements.button.nextElementSibling.classList.add('f-disclosure-list__right')
			}
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.removeAttribute('open')
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			const form = this.querySelector('form');
			this.elements.input.value = event.currentTarget.dataset.value;

			// Determine if it is a country_code or language_code change
			const inputCountry = form.querySelector('input[name="country_code"]');
			const inputLanguage = form.querySelector('input[name="locale_code"]');

			// Get the return_to
			const returnToInput = form.querySelector("input[name='return_to']");
			
			const value = event.currentTarget.dataset.value;

        	// Shop domain
        	let shopDomain = (typeof orbito !== 'undefined' && orbito.getCountryDomain) ? (orbito.getCountryDomain() || window.location.hostname) : window.location.hostname;

			if (inputCountry) {
				// Check if the 'country' parameter exists and if not add it to the URL
				if (returnToInput.value.match(/(\?|&)country=[^&]*/)) {
					// Replace the existing country parameter
					returnToInput.value = returnToInput.value.replace(/(\?|&)country=[^&]*/, `$1country=${value}`);
				} else {
					// Add the country parameter
					if (returnToInput.value.includes('?')) {
						returnToInput.value += `&country=${value}`;
					} else {
						returnToInput.value += `?country=${value}`;
					}
				}

				function setParam(name, value, addIfMissing) {
					if (returnToInput.value.match(new RegExp('(\\?|&)' + name + '=[^&]*'))) {
						// Replace the existing param
						returnToInput.value = returnToInput.value.replace(new RegExp('(\\?|&)' + name + '=[^&]*'), '$1' + name + '=' + value);
					} else if (addIfMissing) {
						// Add the param
						returnToInput.value += (returnToInput.value.includes('?') ? '&' : '?') + name + '=' + value;
					}
				}
				// country: replace or add. oc: only replace if it already exists
				setParam('country', value, true);
				setParam('oc', value, false);

				// Update the Orbe cookie for country code
				document.cookie = `mdApp_countryCodeDomain=${value}; domain=${shopDomain}; path=/; max-age=${60 * 60 * 24 * 60};`;

			} 
			
			//if (inputLanguage) {
				// Update the Orbe cookie for language code
			//	document.cookie = `mdApp_showRecommendationLang=${value}; domain=${shopDomain}; path=/; max-age=${60 * 60 * 24 * 60};`;
			//}

			if (form) form.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.toggleAttribute('open')
			this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
		}

		closeSelector(event) {
			const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON' || event.relatedTarget && !event.relatedTarget.classList.contains('f-disclosure-list__option')
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel(shouldClose);
			}
		}
	}
	customElements.define('localization-form', LocalizationForm);
}
